import HTTP from '@/plugins/axios';

export const getStyles = async(params: { sid: string }) => {
  const response = await HTTP.get('/jobnews/styles', {
    params,
  });
  return response.data;
};
